import axios from '@/axios/globalaxios'

export const findFileByFindType = data =>{
    return axios({
        url: "/tradelab/tFundFundfiles/findFileByFindType",
        method: 'post',
        data:data
    })
}

export const delDraftBox = data =>{
    return axios({
        url: "/tradelab/tFundFundfiles/delDraftBox",
        method: 'post',
        data:data
    })
}

export const findForeignFileByFindType = (data) => {
  return axios({
    url: "/tradelab/currency_files/find",
    method: "post",
    data: data,
  });
};



